<template>
    <base-card
        :key="event.id"
        :image="eventImage"
        :cta="{
            text: 'See Details',
            disabled: false
        }"
        :show-cta="showCta"
        :styles="{
            card: {
                maxWidth: '232px'
            }
        }"
    >
        <template #content-main>
            <div class="opportunity-info">
                <p class="date">{{ event.start_date }}</p>
                <p class="venue-name">
                    {{ event.venue_name ? event.venue_name : event.venue.venue_name }}
                </p>
                <p class="venue-location">
                    {{ event.city_with_state_address.replace(/[0-9]/g, '').trim() }}
                </p>
            </div>
            <p class="vibes">{{ eventVibes }}</p>
        </template>
        <template #footer-text>
            <p class="label">Estimated payout</p>
            <p v-if="!event.venue_budget || event.venue_budget === '0.00'" class="value">
                N/A
            </p>
            <p v-else class="value">Up to ${{ parseFloat(event.venue_budget).toFixed(0) }}</p>
        </template>
    </base-card>
</template>
<script>
    import BaseCard from './BaseCard.vue'
    export default {
        name: 'OpportunityCard',
        components: {
            BaseCard
        },
        props: {
            event: {
                type: Object,
                required: true
            },
            showCta: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        computed: {
            eventVibes: (self) => {
                let keywords

                if (self.event.array_keywords.length > 3) {
                    keywords = self.event.array_keywords.slice(0, 3).join(', ')

                    keywords = `${keywords} and ${
                        self.event.array_keywords.length - 3
                    } more...`
                } else {
                    keywords = self.event.array_keywords.join(', ')
                }

                return keywords
            },
            eventImage: (self) => {
                if (self.event.image && !self.event.image.includes('/global/default.png')) {
                    return self.event.image
                } else if (self.event.venue.main_avatar.includes('/global/default.png')) {
                    return self.URLS.images.defaultEventImage
                } else {
                    return self.event.venue.main_avatar
                }
            }
        },
        methods: {}
    }
</script>
<style lang="scss" scoped>
    .opportunity-info {
        .date {
            color: #dedede;
            font-variant-numeric: ordinal;
            font-family: 'Instrument Sans';
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
        }
        .venue-name,
        .venue-location {
            color: #dedede;
            font-variant-numeric: ordinal;
            font-family: 'Instrument Sans';
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 16px;
        }
    }
    .vibes {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        color: #8b8b8b;
        font-variant-numeric: ordinal;
        text-overflow: ellipsis;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
    }
    .label {
        color: #8b8b8b;
        font-variant-numeric: ordinal;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
    }
    .value {
        color: #acacac;
        font-variant-numeric: ordinal;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
</style>
